module.exports = __webpack_public_path__ + "static/media/membershipIcon.860791ef.png";